module.exports = __webpack_public_path__ + "static/img/8d.84176c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8d.jpg
// module id = xgW4
// module chunks = 0